import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";

import { Space, Breadcrumb, Card, Button } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  ApiKey,Site
} from "../../model/model";

import ApiKeyForm from "./ApiKeyForm";
import SessionStore from "../../model/SessionStore";
import DeleteConfirm from "../../components/DeleteConfirm";

function EditSiteApiKey({ site }: { site: Site }) {
  const navigate = useNavigate();
  const { apiKeyId } = useParams();
  const [apikeyData, setApiKey] = useState<ApiKey | undefined>(undefined);

  useEffect(() => {
    
    SessionStore.getClient().getApiKey(apiKeyId!, SessionStore.getBearer()).then((resp) => {
      setApiKey(resp.data);
    });
  }, [apiKeyId]);

  const onFinish = (obj: ApiKey) => {
   
    SessionStore.getClient().updateApiKey(obj, SessionStore.getBearer()).then(() => {
      navigate(`/site/${site.id}/api-keys`);
    });
  };

  const deleteApiKey = () => {
    if (!apikeyData) {
      return;
    }

    SessionStore.getClient().removeApiKey(apikeyData.id, SessionStore.getBearer()).then( () => {
      navigate(`site/${site.id}/api-keys`);
    });
  };

  if (!apikeyData) {
    return null;
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Api-keys</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to="/api-keys">ApiKeys</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>{apikeyData.name}</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title={apikeyData.name}
        subTitle={`apikeyData id: ${apikeyData.id}`}
        extra={[
          <DeleteConfirm typ="apikeyData" confirm={apikeyData.id} onConfirm={deleteApiKey}>
            <Button danger type="primary">
              Delete apikey
            </Button>
          </DeleteConfirm>,
        ]}
      />
      <Card>
        <ApiKeyForm initialValues={apikeyData} onFinish={onFinish} site={site} />
      </Card>
    </Space>
  );
}

export default EditSiteApiKey;
